<div class="pt-2">
  <label class="form-label">{{ information | abpLocalization }}</label>

  <ng-container *ngFor="let item of rowItems">
    <div *ngIf="item.havePermissions && item.featuresEnabled" class="d-flex">
      <div class="definition-card col" (mousedown)="navigateToDefinition($event, item)">
        <h2>{{ item.label | abpLocalization }}</h2>
        <span class="fal fa-angle-right"></span>
      </div>
      <div class="col"></div>
      <div class="col"></div>
    </div>
  </ng-container>
</div>
